import { render } from "./Position.vue?vue&type=template&id=5749942c"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"

import "./Position.vue?vue&type=style&index=0&id=5749942c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__